<template>
  <div class="analysis-page">
    <!-- 顶部横幅部分 -->
    <div class="section-banner">
      <div class="content">
        <h1>产业洞察和分析</h1>
        <p>利用多源数据挖掘、统计学、机器学习等先进技术，对产业数据进行深度分析，挖掘行业趋势，提供前瞻性洞察，助力企业和政府做出科学决策。</p>
        <div class="actions">
          <el-button class="btn-yellow" type="primary">了解详情</el-button>
          <el-button class="btn-dark" type="primary">&gt;</el-button>
        </div>
      </div>
    </div>

    <!-- 服务卡片部分 -->
    <div class="service-cards">
      <!-- 卡片1 -->
      <div class="service-card">
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/analysis-bg2.png" alt="多源数据融合">
        </div>
        <div class="card-content">
          <h2>多源数据融合合理堆栈，而非构建"产业动态知识图谱"</h2>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>我们整合多种数据源，包括政府公开数据、行业报告、企业财报、社交媒体等，构建全面的产业数据分析基础，确保洞察的广度和深度。</p>
            </div>
          </div>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>通过科学的数据清洗和融合技术，确保数据质量，为后续分析提供可靠依据，避免"垃圾进，垃圾出"的情况发生。</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 卡片2 -->
      <div class="service-card">
        <div class="card-content">
          <h2>分析模型必须"双轮驱动"——定量算法+行业机理</h2>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>我们的分析不仅依赖先进的算法，还结合深厚的行业知识和机理理解，确保分析结果既有数据支撑，又符合产业发展规律。</p>
            </div>
          </div>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>针对不同行业特点定制分析模型，通过定量与定性相结合的方法，提供更加精准、可靠的产业洞察。</p>
            </div>
          </div>
        </div>
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/analysis-bg3.png" alt="双轮驱动分析模型">
        </div>
      </div>

      <!-- 卡片3 -->
      <div class="service-card">
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/analysis-bg4.png" alt="可视化信息卡">
        </div>
        <div class="card-content">
          <h2>洞察化信息无"决策灯杆点"识别，而非数据罗列</h2>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>我们不只是提供数据分析结果，更注重挖掘关键决策点，帮助客户迅速把握核心问题和机会，提升决策效率。</p>
            </div>
          </div>
          <div class="feature">
            <div class="feature-icon">●</div>
            <div class="feature-text">
              <p>通过高效可视化和交互式报告，将复杂数据转化为直观见解，降低理解门槛，提高洞察的可用性。</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 卡片4 -->
      <div class="service-card">
        <div class="card-content table-content">
          <h2>洞察交付物需匹配配置决策场景——分层输出</h2>
          <table class="analysis-table">
            <tr>
              <th>决策层</th>
              <th>形式要求</th>
              <th>内容重点</th>
              <th>交付</th>
            </tr>
            <tr>
              <td style="font-weight: bold">高管层</td>
              <td>一页式图表分析</td>
              <td>全局视野和趋势预判</td>
              <td>战略指导和决策建议</td>
            </tr>
            <tr>
              <td style="font-weight: bold">中层管理</td>
              <td>数据可视化看板</td>
              <td>跨部门协同和资源优化</td>
              <td>关键指标和行动方案</td>
            </tr>
            <tr>
              <td style="font-weight: bold">执行层</td>
              <td>详细数据报告</td>
              <td>精准落地和流程优化</td>
              <td>执行路径和具体步骤</td>
            </tr>
          </table>
        </div>
        <div class="card-image">
          <img src="https://echance.oss-cn-beijing.aliyuncs.com/incubation-bg5.png" alt="分层输出">
        </div>
      </div>
    </div>

    <!-- 服务咨询部分 -->
    <div class="section-contact">
      <div class="contact-content">
        <h2>开启专属服务<br>获取更大价值</h2>
        <el-form class="contact-form" :model="contactForm" :rules="contactRules" ref="contactForm">
          <el-input v-model="contactForm.name" placeholder="您的姓名"></el-input>
          <el-input v-model="contactForm.mobile" placeholder="手机号码"></el-input>
          <div class="actions">
            <el-button class="btn-yellow" type="primary" @click="submitContactForm">Services</el-button>
            <el-button class="btn-dark" type="primary">&gt;</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { saveUserRequirementApi } from '@/api/index';

export default {
  name: 'AnalysisPage',
  data() {
    return {
      contactForm: {
        name: '',
        mobile: '',
        companyName: '测试公司名称',
        demandType: '5' // 洞察分析服务类型
      },
      contactRules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitContactForm() {
      // 判断姓名和手机号是否为空
      if (!this.contactForm.name || this.contactForm.name.trim() === '') {
        this.$message.error('请输入您的姓名');
        return;
      }
      if (!this.contactForm.mobile || this.contactForm.mobile.trim() === '') {
        this.$message.error('请输入手机号码');
        return;
      }
      
      this.$refs.contactForm.validate(valid => {
        if (valid) {
          saveUserRequirementApi(this.contactForm).then(res => {
            this.$message.success('提交成功');
            this.contactForm.name = '';
            this.contactForm.mobile = '';
          }).catch(err => {
            this.$message.error('提交失败，请稍后重试');
            console.error(err);
          });
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.analysis-page {
  width: 100%;
  background-color: #fff;
  color: #333;
}

// 顶部横幅
.section-banner {
  height: 1080px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/analysis-bg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  color: #fff;

  .content {
    width: 1200px;
    margin: 0 auto;
    padding-top: 345px;

    h1 {
      font-weight: bold;
      font-size: 78px;
      line-height: 92px;
      margin-bottom: 30px;
    }

    p {
      font-size: 17px;
      font-weight: bold;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      line-height: 25px;
      margin-bottom: 70px;
      max-width: 700px;
    }

    .actions {
      display: flex;

      .btn-yellow {
        background-color: #ffc107;
        border-color: #ffc107;
        color: #0F0FB1;
        width: 150px;
        height: 50px;
        font-size: 20px;
        font-weight: bold;
        line-height: 22px;
      }
      
      .btn-dark {
        background-color: #002366;
        border-color: #002366;
        color: #fff;
        width: 50px;
        height: 50px;
        margin-left: -5px;
      }
    }
  }
}

// 服务卡片区域
.service-cards {
  width: 1200px;
  margin: 80px auto;
}

.service-card {
  display: flex;
  justify-content: space-between;
  margin-bottom: 80px;

  .card-image {
    width: 45%;
    img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }

  .card-content {
    width: 45%;
    padding: 20px 0;

    h2 {
      font-weight: bold;
      font-size: 32px;
      color: #19456B;
      line-height: 42px;
      margin-bottom: 30px;
    }

    .feature {
      display: flex;
      margin-bottom: 20px;

      .feature-icon {
        color: #4CAF50;
        font-size: 20px;
        margin-right: 10px;
        margin-top: 2px;
      }

      .feature-text {
        p {
          font-size: 17px;
          color: #382933;
          line-height: 25px;
          margin: 0;
        }
      }
    }
  }
}

// 服务咨询部分
.section-contact {
  margin: 0 auto 100px;
  width: 1200px;
  height: 340px;
  box-sizing: border-box;
  padding: 40px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/bg-contact.png');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;

  .contact-content {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    h2 {
      font-weight: bold;
      font-size: 48px;
      color: #FFFFFF;
      line-height: 52px;
    }

    .contact-form {
      display: block;

      .el-input {
        width: 350px;
        display: block;
        margin-bottom: 25px;

        ::v-deep .el-input__inner {
          background-color: transparent;
          border: none;
          border-bottom: 2px solid rgba(255, 255, 255, 0.5);
          border-radius: 0;
          padding-left: 0;
          height: 50px;
          font-size: 24px;
          color: #FFFFFF;
          line-height: 24px;

          &:focus {
            border-bottom-color: #fff;
          }

          &::placeholder {
            color: #ccc;
            font-size: 24px;
          }
        }
      }

      .actions {
        display: flex;

        .btn-yellow {
          background-color: #ffc107;
          border-color: #ffc107;
          color: #0F0FB1;
          width: 150px;
          height: 50px;
          font-size: 20px;
          font-weight: bold;
          line-height: 22px;
        }

        .btn-dark {
          background-color: #002366;
          border-color: #002366;
          color: #fff;
          width: 50px;
          height: 50px;
          margin-left: -5px;
        }
      }
    }
  }
}

// 表格样式
.table-content {
  width: 50%;
  
  .analysis-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
    
    th, td {
      border: 1px solid #ddd;
      padding: 10px;
      text-align: left;
      font-size: 17px;
      color: #666666;
      line-height: 25px;
    }
    
    th {
      background-color: #f2f2f2;
      color: #19456B;
      font-weight: bold;
    }
    
    tr:nth-child(even) {
      background-color: #f9f9f9;
    }
    
    tr:hover {
      background-color: #f0f7fa;
    }
  }
}
</style>